import type { SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const state = (data: SSO_MODELS.State) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    key: data?.system?.codename,
    label: elements?.name?.value,
    value:  elements?.code?.value,
  };
};

export default state;
